import ProgressDialog from '@/components/common/dialog/ProgressDialog.vue';
import { h, render } from 'vue';

/**
 * 进度弹窗暴露接口
 */
interface IProgressExpose {
  update: (p: number, msg?: string, title?: string) => void;
  close: () => void;
}

type CloseCallback = () => void;

/**
 * 进度弹窗单例类
 */
class ProgressManager {
  private static instance: ProgressManager | null = null;
  private container: HTMLElement | null = null;
  private exposed: IProgressExpose | null = null;

  private constructor() {}

  /**
   * 获取单例实例
   */
  static getInstance(): ProgressManager {
    if (!ProgressManager.instance) {
      ProgressManager.instance = new ProgressManager();
    }
    return ProgressManager.instance;
  }

  /**
   * 销毁当前弹窗
   */
  private destroy() {
    if (this.container) {
      render(null, this.container); // 卸载组件
      this.container.remove(); // 移除 DOM
      this.container = null;
    }
    this.exposed = null;
  }

  /**
   * 显示进度弹窗
   * @param title 弹窗标题
   * @param canClose 是否可关闭
   * @param closeCallback 只有canClose为true时才能触发，主要用于显示关闭按键时，取消正在进行中的操作
   */
  show(title = '进度提示', canClose = false, closeCallback?: CloseCallback) {
    // 如果已有实例，强制销毁旧的（用于快速切换，不等待关闭动画）
    // this.destroy();
    // 如果有挂载容器，直接返回，在调用close前，不创建新的
    if (this.container) return;

    // 创建挂载容器
    this.container = document.createElement('div');

    // 创建 VNode
    const vnode = h(ProgressDialog, {
      title,
      canClose,
      onDestroy: () => {
        if (canClose && closeCallback) closeCallback();
        this.destroy();
      }
    });

    // 渲染并挂载
    render(vnode, this.container);
    document.body.appendChild(this.container);

    // 强制浏览器计算布局，确保 el-progress 的初始 width 被"确认"，
    // 否则后续 update() 改变进度时 CSS transition 没有起始状态，动画不生效
    void document.body.offsetHeight;

    // 获取并保存组件暴露的方法
    this.exposed = vnode.component?.exposed as IProgressExpose;
  }

  /**
   * 更新进度
   */
  update(percentage: number, message?: string, title?: string): void {
    // 强制浏览器计算当前布局，使 el-progress 当前 width 成为 CSS transition 的有效起点
    void document.body.offsetHeight;
    this.exposed?.update(percentage, message, title);
  }

  /**
   * 关闭弹窗
   */
  close(): void {
    this.exposed?.close();
  }
}

// 导出单例实例
export const progressManager = ProgressManager.getInstance();
